<template>
  <div class="ls-box-filter ls-no-margin-top">
    <form class="ls-form ls-form-horizontal row">
      <fieldset>
        <div class="col-xlg-12">
          <label class="ls-label col-xlg-2 col-lg-3 col-md-6 col-xs-6">
            <b class="ls-label-text">{{ $t('contracts.attributes.id') }}</b>
            <input class="input is-expanded" :maxlength="9" type="text" @keyup="addFilterContracts('search_id', $event)" v-model="search_id" placeholder='Ex.: 10'>
          </label>
          <label class="ls-label col-xlg-2 col-lg-3 col-md-6 col-xs-6">
            <b class="ls-label-text">{{ $t('application.filter.day_expiration')}}</b>
            <input type="text" class="input is-expanded" @keyup="addFilterContracts('search_day_expiration', $event)" v-model="search_day_expiration" placeholder='Ex.: 12'>
          </label>
          <label class="ls-label col-xlg-2 col-lg-3 col-md-6 col-xs-12">
            <b class="ls-label-text">{{ $t('application.filter.code')}}</b>
            <input type="text" class="input is-expanded" @keyup="addFilterContracts('search_code', $event)" v-model="search_code" placeholder='Ex.: Ab123'>
          </label>
          <label class="ls-label col-xlg-2 col-lg-3 col-md-6 col-xs-12">
            <b class="ls-label-text">{{ $t('contracts.attributes.client') }}</b>
            <input class="input is-expanded" type="text" @keyup="addFilterContracts('search_email', $event)" v-model="search_email" :placeholder="$t('contracts.placeholder.name_or_email')">
          </label>
          <div class="ls-label col-xlg-2 col-lg-3 col-md-6 col-xs-6">
            <b class="ls-label-text">{{ $t('contracts.attributes.plans') }}</b>
            <div class="ls-custom-select">
              <select class="ls-select" v-model="search_plan">
                <option v-for="option in options_plan" v-bind:value="option.value">
                  {{ option.name }}
                </option>
              </select>
            </div>
          </div>
          <label class="ls-label col-xlg-2 col-lg-3 col-md-6 col-xs-6">
            <b class="ls-label-text">{{ $t('contracts.attributes.status') }}</b>
            <div class="ls-custom-select">
              <select v-model="search_active" class="ls-select" :placeholder="$t('contracts.placeholder.status')">
                <option value="">{{ $t('application.filter.all') }}</option>
                <option value="1">{{ $t('contracts.attributes.statuses.pending') }}</option>
                <option value="2">{{ $t('contracts.attributes.statuses.active') }}</option>
                <option value="3">{{ $t('contracts.attributes.statuses.inactive') }}</option>
                <option value="4">{{ $t('contracts.attributes.statuses.overdue') }}</option>
                <option value="5">{{ $t('contracts.attributes.statuses.canceled') }}</option>
              </select>
            </div>
          </label>
        </div>
        <div>
          <label class="ls-label col-xlg-2 col-lg-3 col-md-6 col-xs-12">
            <b class="ls-label-text">{{ $t('application.filter.init_value') }}</b>
            <money-input v-model="search_price_gt" :value="search_price_gt" @updateValue="(value) => { setFilter('search_price_gt', value) }"></money-input>
          </label>
          <label class="ls-label col-xlg-2 col-lg-3 col-md-6 col-xs-12">
            <b class="ls-label-text">{{ $t('application.filter.end_value') }}</b>
            <money-input v-model="search_price_lt" :value="search_price_lt" @updateValue="(value) => { setFilter('search_price_lt', value) }"></money-input>
          </label>
          <label class="ls-label col-xlg-2 col-lg-3 col-md-6 col-xs-12">
            <b class="ls-label-text">{{ $t('application.filter.contract_init_date') }}</b>
            <div class="ls-prefix-group ls-full-width">
              <input v-model="search_created_gt" type="date" @keyup="addFilterContracts('search_created_gt', $event)" @change="addFilterContracts('search_created_gt', $event)">
            </div>
          </label>
          <label class="ls-label col-xlg-2 col-lg-3 col-md-6 col-xs-12">
            <b class="ls-label-text">{{ $t('application.filter.contract_end_date') }}</b>
            <div class="ls-prefix-group ls-full-width">
              <input v-model="search_created_lt" type="date" @keyup="addFilterContracts('search_created_lt', $event)" @change="addFilterContracts('search_created_lt', $event)">
            </div>
          </label>
          <label class="ls-label col-xlg-2 col-lg-3 col-md-6 col-xs-12">
            <b class="ls-label-text">{{ $t('application.filter.charge_type') }}</b>
            <div class="ls-custom-select">
              <select v-model="search_post_paid" class="ls-select" :placeholder="$t('contracts.placeholder.charge_type')">
                <option value="">{{ $t('application.filter.all') }}</option>
                <option value="true">{{ $t('contracts.attributes.charge_types.post_paid') }}</option>
                <option value="false">{{ $t('contracts.attributes.charge_types.pre_paid') }}</option>
              </select>
            </div>
          </label>
          <div class="col-lg-4 col-xlg-4 col-md-6 col-xs-12 ls-float-right">
            <div class="ls-float-right">
              <button type="button" class="ls-btn-danger ls-no-margin-bottom" @click="clearFilters" @keyup.enter="clearFilters">
                <i class="fa fa-eraser" aria-hidden="true"></i>
                <span class="ls-xs-margin-left">{{ $t('application.filter.clear_filters') }}</span>
              </button>
              <button type="button" class="ls-btn ls-no-margin-bottom" v-on:click="searchContracts">
                <i class="fa fa-search" aria-hidden="true"></i>
                <span>{{ $t('application.filter.filter') }}</span>
              </button>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
    <div class="column is-5">
    </div>
  </div>
</template>
<script type="text/javascript">
  import { mapGetters, mapActions } from 'vuex'
  import { setFilterContract, clearFilterContract } from 'src/app/pages/contracts/vuex/mutations-types'
  import { setPagination } from 'src/app/components/shareds/pagination/vuex/mutations-types'
  import MoneyInput from 'src/app/components/shareds/money-input/MoneyInput'
  import filter from 'src/utils/filter'

  export default {
    components: { MoneyInput },
    data () {
      return {
        search_id: '',
        search_email: '',
        search_code: '',
        search_day_expiration: '',
        search_price_lt: '',
        search_price_gt: '',
        search_created_lt: '',
        search_created_gt: '',
        search_post_paid: 'all',
        search_plan: '',
        search_active: 'all',
        options_plan: []
      }
    },
    mounted () {
      this.getPlans()
      this.$parent.$on('clearFilters', this.clearFilters)
      this.$watch('search_active', function (val) {
        this.addFilterContracts('search_active')
      })
      this.$watch('search_post_paid', (val) => {
        this.addFilterContracts('search_post_paid')
      })
      this.$watch('search_plan', function (val) {
        this.addFilterContracts('search_plan')
      })
    },
    computed: {
      ...mapGetters(['pagination', 'plans', 'filterContracts'])
    },
    methods: {
      ...mapActions(['loadPlans']),
      searchContracts () {
        this.$store.commit(setPagination, { per_page: 10, current_page: 1 })
        this.$parent.getContracts()
      },
      addFilterContracts (key, e) {
        this.updateFilter(key, this[key])
        if (e && e.key === 'Enter') {
          this.searchContracts()
        }
      },
      setFilter (attribute, value) {
        if (value <= 0) return
        this[attribute] = value
        this.updateFilter(attribute, value)
      },
      updatePriceLT (event) {
        this.addFilterContracts('search_price_lt', event)
      },
      updatePriceGT (event) {
        this.addFilterContracts('search_price_gt', event)
      },
      updateFilter (key, value) {
        var val = value && value.value ? value.value : value
        key = this.findKey(key)
        if (val !== '' && val !== 'NaN') {
          this.$store.commit(setFilterContract, { key: key, value: val })
        } else {
          this.$store.commit(clearFilterContract, key)
        }
      },
      populateData () {
        this.search_id = this.$route.query['contract[id]']
        this.search_code = this.$route.query['contract[code]']
        this.search_post_paid = this.$route.query['contract[post_paid]']
        this.search_day_expiration = this.$route.query['contract[day_expiration]']
        this.search_email = this.$route.query['contract[customer][name_or_email]']
        this.search_active = this.$route.query['contract[status]']
        this.search_plan = this.$route.query['contract[contract_plans][plan_code]']
        this.search_price_lt = this.$route.query['contract[contract_plans][price_lt]']
        this.search_price_gt = this.$route.query['contract[contract_plans][price_gt]']
        this.search_created_lt = this.$route.query['contract[created_at_lt]']
        this.search_created_gt = this.$route.query['contract[created_at_gt]']
      },
      findKey (key) {
        switch (key) {
          case 'search_id': return 'contract[id]'
          case 'search_code': return 'contract[code]'
          case 'search_day_expiration': return 'contract[day_expiration]'
          case 'search_email': return 'contract[customer][name_or_email]'
          case 'search_active': return 'contract[status]'
          case 'search_post_paid': return 'contract[post_paid]'
          case 'search_plan': return 'contract[contract_plans][plan_code]'
          case 'search_price_lt': return 'contract[contract_plans][price_lt]'
          case 'search_price_gt': return 'contract[contract_plans][price_gt]'
          case 'search_created_lt': return 'contract[created_at_lt]'
          case 'search_created_gt': return 'contract[created_at_gt]'
        }
      },
      getPlans () {
        this.$loader.show()
        var params = filter.toQueryWithPagination({}, this.pagination, 999)
        this.loadPlans(params).then(this.afterLoad)
      },
      afterLoad () {
        this.$loader.hide()
        this.options_plan = this.getPlanIds()
      },
      getPlanIds () {
        var opts = [{ value: '', name: 'Todos' }]
        for (var plan of this.plans) {
          opts.push({ value: plan.code, name: plan.name })
        }
        this.populateData()
        return opts
      },
      clearFilters () {
        var allAttributes = this.attributes()
        for (var i in allAttributes) {
          this.updateFilter(allAttributes[i], '')
          this[allAttributes[i]] = ''
        }
        this.search_price_gt = 0
        this.search_price_lt = 0
        this.searchContracts()
      },
      attributes () {
        return ['search_id', 'search_code', 'search_day_expiration', 'search_email', 'search_price_lt', 'search_price_gt', 'search_created_lt', 'search_created_gt', 'search_plan', 'search_active', 'search_post_paid']
      }
    }
  }
</script>
<style scoped lang="scss">
  label.ls-label-text span {
    position: relative;
    top: -12px;
    left: 5px;
  }
  .d-flex {
    display: flex;
    justify-content: space-between !important;
  }
</style>



// WEBPACK FOOTER //
// Filter.vue?f48b9592